(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fit-clean"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const cleanGrid = document.getElementById('cleanGrid');
  if (!cleanGrid) return;
  new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) cleanGrid.classList.add('revealed'); }), {threshold:0.3}).observe(cleanGrid);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-featured"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const magneticGrid = document.getElementById('magneticGrid');
  if (magneticGrid && !reduced) {
    magneticGrid.addEventListener('mousemove', e => {
      magneticGrid.querySelectorAll('.mag-card').forEach(card => {
        const r = card.getBoundingClientRect(), cx = r.left+r.width/2, cy = r.top+r.height/2;
        const dx = e.clientX-cx, dy = e.clientY-cy, dist = Math.hypot(dx,dy);
        const s = Math.max(0, 1-dist/260);
        card.style.transform = `translate(${-dx*0.06*s}px, ${-dy*0.06*s}px) scale(${1+s*0.05})`;
      });
    });
    magneticGrid.addEventListener('mouseleave', () => magneticGrid.querySelectorAll('.mag-card').forEach(c => c.style.transform = ''));
  }

  if (!reduced) {
    document.querySelectorAll('#tiltGrid .tilt-card').forEach(card => {
      card.addEventListener('mousemove', e => {
        const r = card.getBoundingClientRect();
        const px = (e.clientX-r.left)/r.width-0.5, py = (e.clientY-r.top)/r.height-0.5;
        card.style.transform = `perspective(700px) rotateY(${px*14}deg) rotateX(${-py*14}deg) scale(1.03)`;
      });
      card.addEventListener('mouseleave', () => card.style.transform = 'perspective(700px) rotateY(0) rotateX(0) scale(1)');
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-footer"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('magBtn');
  if (!btn || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  btn.addEventListener('mousemove', e => {
    const r = btn.getBoundingClientRect();
    btn.style.transform = `translate(${(e.clientX-r.left-r.width/2)*0.3}px, ${(e.clientY-r.top-r.height/2)*0.3}px)`;
  });
  btn.addEventListener('mouseleave', () => btn.style.transform = 'translate(0,0)');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const heroVideo = document.getElementById('heroVideo');
  heroVideo.muted = true;
  heroVideo.play().catch(()=>{ /* browser blocked autoplay; poster still shows */ });

  const heroSoundBtn = document.getElementById('heroSoundBtn');
  heroSoundBtn.addEventListener('click', () => {
    heroVideo.muted = !heroVideo.muted;
    heroSoundBtn.classList.toggle('is-muted', heroVideo.muted);
    heroSoundBtn.setAttribute('aria-pressed', String(!heroVideo.muted));
    if (!heroVideo.muted) heroVideo.play().catch(()=>{});
  });

  document.getElementById('exploreBtn')?.addEventListener('click', () => {
    document.getElementById('story')?.scrollIntoView({behavior:'smooth'});
  });

  const introMark = document.getElementById('introMark');
  const introLines = document.getElementById('introLines');
  setTimeout(() => {
    introMark.classList.add('play');
    introLines.classList.add('play');
  }, 400);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-lookbok"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  // swap in real recently-viewed products if this visitor has browsing history
  try {
    const viewed = JSON.parse(localStorage.getItem('fitnexaRecentlyViewed') || '[]');
    if (viewed.length > 0) {
      const track = document.getElementById('lookbookTrack');
      track.innerHTML = viewed.slice(0, 5).map(p => `
        <a class="lb-card" href="${p.url}">
          <img src="${p.image}" alt="" loading="lazy">
          <div class="lb-info">
            <div class="lb-name">${p.title}</div>
            <div class="lb-price">${p.price}</div>
          </div>
        </a>
      `).join('');
    }
  } catch(e) {}

  const outer = document.getElementById('lookbookOuter');
  const track = document.getElementById('lookbookTrack');
  if (!outer || !track) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let visible = false;
  new IntersectionObserver(es => es.forEach(e => visible = e.isIntersecting), {threshold:0}).observe(outer);

  (function loop(){
    if (!reduced && visible) {
      const r = outer.getBoundingClientRect();
      const total = outer.offsetHeight - window.innerHeight;
      const p = Math.min(Math.max(-r.top/total, 0), 1);
      const maxShift = track.scrollWidth - window.innerWidth + 100;
      track.style.transform = `translateX(-${p*maxShift}px)`;
    }
    requestAnimationFrame(loop);
  })();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-marquee"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const track = document.getElementById('marqueeTrack');
  if (!track) return;
  track.querySelectorAll('.m-card').forEach(card => {
    card.addEventListener('mouseenter', () => track.classList.add('paused'));
    card.addEventListener('mouseleave', () => track.classList.remove('paused'));
    card.addEventListener('touchstart', () => track.classList.add('paused'), {passive:true});
    card.addEventListener('touchend', () => track.classList.remove('paused'));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-parallax"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const parallaxImg = document.getElementById('parallaxImg');
  const parallaxSection = document.querySelector('.col-parallax');
  if (!parallaxImg || !parallaxSection) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let parallaxVisible = false;
  new IntersectionObserver(es => es.forEach(e => parallaxVisible = e.isIntersecting), {threshold:0}).observe(parallaxSection);

  function updateParallax(){
    if (!reduced && parallaxVisible) {
      const rect = parallaxSection.getBoundingClientRect();
      const vh = window.innerHeight;
      const progress = Math.min(Math.max((vh-rect.top)/(vh+rect.height),0),1);
      parallaxImg.style.transform = `translateY(${(progress-0.5)*120}px)`;
    }
    requestAnimationFrame(updateParallax);
  }
  requestAnimationFrame(updateParallax);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-split"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const splitFeature = document.getElementById('splitFeature');
  if (!splitFeature) return;
  new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) splitFeature.classList.add('revealed'); }), {threshold:0.3}).observe(splitFeature);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-strip"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const strip = document.getElementById('statStrip');
  if (!strip) return;
  new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) strip.classList.add('revealed'); }), {threshold:0.3}).observe(strip);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-trust"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const heading = document.getElementById('ctaHeading');
  if (!heading) return;
  new IntersectionObserver(es => es.forEach(e => heading.classList.toggle('revealed', e.isIntersecting)), {threshold:0.45}).observe(heading);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('magBtn');
  if (!btn || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  btn.addEventListener('mousemove', e => {
    const r = btn.getBoundingClientRect();
    btn.style.transform = `translate(${(e.clientX-r.left-r.width/2)*0.3}px, ${(e.clientY-r.top-r.height/2)*0.3}px)`;
  });
  btn.addEventListener('mouseleave', () => btn.style.transform = 'translate(0,0)');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  requestAnimationFrame(() => document.body.classList.add('loaded'));

  if (!reduced && window.matchMedia('(pointer:fine)').matches) {
    const glow = document.getElementById('cursorGlow');
    let gx = innerWidth/2, gy = innerHeight/2, tx = gx, ty = gy;
    addEventListener('mousemove', e => { tx = e.clientX; ty = e.clientY; glow.classList.add('active'); });
    addEventListener('mouseleave', () => glow.classList.remove('active'));
    (function loop(){ gx += (tx-gx)*0.12; gy += (ty-gy)*0.12; glow.style.transform = `translate(${gx}px, ${gy}px) translate(-50%,-50%)`; requestAnimationFrame(loop); })();
  }

  const scrollBar = document.getElementById('scrollBar');
  const topBtn = document.getElementById('topBtn');
  addEventListener('scroll', () => {
    const h = document.documentElement;
    scrollBar.style.width = (h.scrollTop/(h.scrollHeight-h.clientHeight)*100)+'%';
    topBtn.classList.toggle('show', h.scrollTop > 600);
  }, {passive:true});
  topBtn.addEventListener('click', () => scrollTo({top:0, behavior:'smooth'}));

  document.querySelector('.burger')?.addEventListener('click', () => {
    document.querySelectorAll('.nav-links a:not(.btn)').forEach(a => a.style.display = a.style.display === 'block' ? 'none' : 'block');
  });

  const bgAudio = document.getElementById('bgAudio');
  const soundBtn = document.getElementById('soundBtn');
  if (soundBtn && bgAudio) {
    let started = false;
    const setIcon = playing => soundBtn.setAttribute('aria-pressed', playing);
    addEventListener('scroll', () => { if (started || !bgAudio.src) return; started = true; bgAudio.play().then(()=>setIcon(true)).catch(()=>setIcon(false)); }, {once:true, passive:true});
    soundBtn.addEventListener('click', () => { if (!bgAudio.src) return; bgAudio.paused ? bgAudio.play().then(()=>setIcon(true)) : (bgAudio.pause(), setIcon(false)); });
  }

  const preview = document.getElementById('productPreview');
  const ppName = document.getElementById('ppName'), ppPrice = document.getElementById('ppPrice'),
        ppVariants = document.getElementById('ppVariants'), ppMeta = document.getElementById('ppMeta');

  function fillPreview(el){
    const name = el.dataset.productName; if (!name) return false;
    ppName.textContent = name;
    ppPrice.textContent = el.dataset.productPrice || '';
    const variants = (el.dataset.productVariants || '').split(',').map(v=>v.trim()).filter(Boolean);
    ppVariants.innerHTML = variants.map(v => `<span>${v}</span>`).join('');
    const inStock = el.dataset.productStock === 'in';
    ppMeta.innerHTML = `<span class="pp-stock ${inStock?'in':''}"></span>${inStock?'In stock':'Restocking'} · ${el.dataset.productShipping || ''}`;
    return true;
  }
  function position(x,y){
    const w = preview.offsetWidth||230, h = preview.offsetHeight||140;
    preview.style.left = Math.min(Math.max(x,12), innerWidth-w-12)+'px';
    preview.style.top = Math.min(Math.max(y,12), innerHeight-h-12)+'px';
  }
  document.addEventListener('mouseenter', e => {
    const el = e.target.closest?.('[data-product-name]'); if(!el) return;
    if (fillPreview(el)) { position(e.clientX+18, e.clientY+18); preview.classList.add('show'); }
  }, true);
  document.addEventListener('mousemove', e => {
    if (e.target.closest?.('[data-product-name]')) position(e.clientX+18, e.clientY+18);
  });
  document.addEventListener('mouseleave', e => {
    if (e.target.closest?.('[data-product-name]')) preview.classList.remove('show');
  }, true);
  document.addEventListener('touchstart', e => {
    const el = e.target.closest?.('[data-product-name]'); if(!el) return;
    if (!fillPreview(el)) return;
    const r = el.getBoundingClientRect();
    position(r.left, Math.max(r.top-10,10));
    preview.classList.add('show');
    clearTimeout(el._ppT);
    el._ppT = setTimeout(()=>preview.classList.remove('show'), 2600);
  }, {passive:true});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
